class MegaMenuCustom {
  constructor(root) {
    this.root = root;
    this.backdrop = root.querySelector('[data-mega-menu-custom-backdrop]');
    this.panelsContainer = root.querySelector('[data-mega-menu-custom-panels]');
    this.allTriggers = root.querySelectorAll('[data-mega-menu-custom-trigger]');
    this.allPanels = root.querySelectorAll('[data-mega-menu-custom-panel]');

    // Mover al body solo si existen, para no romper el script
    if (this.backdrop) document.body.appendChild(this.backdrop);
    if (this.panelsContainer) document.body.appendChild(this.panelsContainer);

    this.bindEvents();
  }

  bindEvents() {
    this.allTriggers.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handleTrigger(btn);
      });
    });

    this.backdrop.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) this.close();
    });
  }

  get isOpen() {
    return this.root.classList.contains('is-open');
  }

  isRootTrigger(targetId) {
    // Los raíz tienen formato "root-N", los sub tienen "sub-N-M"
    return targetId.startsWith('root-');
  }

  handleTrigger(btn) {
    const targetId = btn.dataset.megaMenuCustomTrigger;
    const isRoot = this.isRootTrigger(targetId);
    const isAlreadyActive = btn.classList.contains('is-active');

    if (isRoot) {
      // Click en item raíz ya activo → cerrar todo
      if (isAlreadyActive) {
        this.close();
        return;
      }
      // Cambio de raíz: cerrar lo anterior, abrir el nuevo
      this.closeAllPanels();
      this.deactivateAllTriggers();
      this.open();
      const panel = this.getPanel(targetId);
      if (panel) this.activate(btn, panel);
      return;
    }

    // Click en sub-trigger (segundo nivel)
    const panel = this.getPanel(targetId);
    if (!panel) return;
    const rootId = panel.dataset.megaMenuCustomRoot;

    // Cerrar SOLO los paneles de nivel 2 del mismo root (mantenemos el nivel 1 abierto)
    this.closeLevel(2, rootId);

    // Si el botón ya estaba activo, lo dejamos cerrado (toggle)
    if (!isAlreadyActive) {
      this.activate(btn, panel);
    }
  }

  getPanel(id) {
    return this.panelsContainer.querySelector(`[data-mega-menu-custom-panel="${id}"]`);
  }

  activate(btn, panel) {
    btn.classList.add('is-active');
    btn.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-active');
    panel.setAttribute('aria-hidden', 'false');
  }

  closeLevel(level, rootId) {
    this.allPanels.forEach((panel) => {
      if (
        panel.dataset.megaMenuCustomLevel === String(level) &&
        panel.dataset.megaMenuCustomRoot === rootId
      ) {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      }
    });
    this.allTriggers.forEach((btn) => {
      const targetId = btn.dataset.megaMenuCustomTrigger;
      const panel = this.getPanel(targetId);
      if (
        panel &&
        panel.dataset.megaMenuCustomLevel === String(level) &&
        panel.dataset.megaMenuCustomRoot === rootId
      ) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  closeAllPanels() {
    this.allPanels.forEach((p) => {
      p.classList.remove('is-active');
      p.setAttribute('aria-hidden', 'true');
    });
  }

  deactivateAllTriggers() {
    this.allTriggers.forEach((b) => {
      b.classList.remove('is-active');
      b.setAttribute('aria-expanded', 'false');
    });
  }

  open() {
    this.root.classList.add('is-open');
    this.backdrop.classList.add('is-open');
    this.panelsContainer.classList.add('is-open');
    document.documentElement.classList.add('menu-open');   /* nuevo */
    this.panelsContainer.setAttribute('aria-hidden', 'false');
    this.backdrop.hidden = false;
  }

  close() {
    this.root.classList.remove('is-open');
    this.backdrop.classList.remove('is-open');
    this.panelsContainer.classList.remove('is-open');
    document.documentElement.classList.remove('menu-open');   /* nuevo */
    this.panelsContainer.setAttribute('aria-hidden', 'true');
    this.backdrop.hidden = true;
    this.closeAllPanels();
    this.deactivateAllTriggers();
  }
}

// Ajuste del topbar: 40px cuando no se ha scrolleado, 0 cuando sí
(function () {
  const TOPBAR_HEIGHT = 40;
  const root = document.documentElement;

  function updateTopbarOffset() {
    // Si estamos arriba del todo, el topbar está visible → 40px de offset
    const scrolled = window.scrollY > TOPBAR_HEIGHT;
    root.style.setProperty('--topbar-offset', scrolled ? '0px' : TOPBAR_HEIGHT + 'px');
  }

  updateTopbarOffset();
  window.addEventListener('scroll', updateTopbarOffset, { passive: true });
})();

// === Estado "scrolled" del header para legibilidad ===
(function () {
  const root = document.documentElement;
  const THRESHOLD = 40; // igual que la altura del topbar
  function onScroll() {
    if (window.scrollY > THRESHOLD) {
      root.classList.add('is-scrolled');
    } else {
      root.classList.remove('is-scrolled');
    }
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

document.querySelectorAll('[data-mega-menu-custom]').forEach((el) => new MegaMenuCustom(el));